// extracted by mini-css-extract-plugin
export default {"limit":"AddNewMedia_limit__ML5H7","input_file":"AddNewMedia_input_file__3A4jS"};